import React from 'react';
import Typography from '@mui/material/Typography';

export default function RelatorioCabecalhoWeb({ alunoTurma }) {

    return (

        <div style={{
            border: '1px solid black',
            padding: '20px',
            margin: '20px'
        }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-evenly'
            }}>
                <Typography >
                    Código: {alunoTurma.aluno.codAlunoEscola}
                </Typography>
                <Typography >
                    Aluno: {alunoTurma.aluno.nome}
                </Typography>
                <Typography >
                    Turma: {alunoTurma.turma.descricao}
                </Typography>
                <Typography >
                    Ano Letivo: {alunoTurma.turma.anoLetivo}
                </Typography>
                {alunoTurma.resultadoFinal &&
                    <Typography >
                        Resultado Final: {alunoTurma.resultadoFinal}
                    </Typography>
                }

            </div>
        </div>

    );
}